<div class="grid-container v-pad">
  <section>
    <h2>Create Entity</h2>

    <form class="grid-x grid-margin-x" #formDiv="ngForm" [formGroup]="createEntityForm">
      <div class="cell medium-6">
        <label for="name">Name:</label>
        <input id="name" type="text" formControlName="name" required>
        @if (name.invalid && (name.dirty || name.touched)) {
          <div class="error-container">
            @if (name.errors.required) {
              <small class="error">Name is required.</small>
            }
            @if (name.errors.entityNotUnique) {
              <small class="error">Entity must have a unique name.</small>
            }
            @if (name.errors.minlength) {
              <small class="error">Name must be at least 4 characters long.</small>
            }
          </div>
        }
      </div>
      <div class="cell medium-6">
        <label for="desc">Description:</label>
        <input id="desc" type="text" formControlName="desc" required>
        @if (desc.invalid && (desc.dirty || desc.touched)) {
          <div class="error-container">
            @if (desc.errors.required) {
              <small class="error">Description is required.</small>
            }
            @if (desc.errors.minlength) {
              <small class="error">Description must be at least 4 characters long.</small>
            }
          </div>
        }
      </div>
    </form>

    <button class="button" (click)="saveEntity()" [disabled]="formDiv.invalid" aria-label="Create New Entity">Create</button>
  </section>

  <section class="major-margin-top">
    <h2>Existing Entities</h2>
    @if (showListError) {
      <div class="red">An error has occurred in loading the entity list.  Please try again later.</div>
    }
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" aria-label="Entitylist"></ag-grid-angular>
  </section>
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
